import { Paths } from '../shared/paths';
import {
  IOnboardingBlockDefinition,
  IOnboardingBlockKey,
  ONBOARDING_BLOCK_KEYS,
} from './onboarding.types';

export const onboardingBlockDefinitions: IOnboardingBlockDefinition[] = [
  {
    blockKey: 'general',
    matchesRoute: () => true,
    getSteps: ({ mobileView, t }) => {
      const prefix = mobileView ? 'footer' : 'menu';

      return [
        {
          target: `[data-onboarding="general.${prefix}.trainings"]`,
          title: t('onboarding.general.trainings.title'),
          content: t('onboarding.general.trainings.content'),
          disableBeacon: true,
          placement: mobileView ? 'top' : 'right',
        },
        {
          target: `[data-onboarding="general.${prefix}.programs"]`,
          title: t('onboarding.general.programs.title'),
          content: t('onboarding.general.programs.content'),
          disableBeacon: true,
          placement: mobileView ? 'top' : 'right',
        },
        {
          target: `[data-onboarding="general.${prefix}.exercises"]`,
          title: t('onboarding.general.exercises.title'),
          content: t('onboarding.general.exercises.content'),
          disableBeacon: true,
          placement: mobileView ? 'top' : 'right',
        },
        {
          target: `[data-onboarding="general.${prefix}.statistics"]`,
          title: t('onboarding.general.statistics.title'),
          content: t('onboarding.general.statistics.content'),
          disableBeacon: true,
          placement: mobileView ? 'top' : 'right',
        },
      ];
    },
  },
  {
    blockKey: 'newExercise',
    matchesRoute: (pathname) => pathname === Paths.exercises.toNew(),
    getSteps: ({ t, mobileView }) => [
      {
        target: '[data-onboarding="newExercise.mainMuscleGroup"]',
        title: t('onboarding.newExercise.mainMuscleGroup.title'),
        content: t('onboarding.newExercise.mainMuscleGroup.content'),
        disableBeacon: true,
        placement: mobileView ? 'top' : 'bottom',
      },
      {
        target: '[data-onboarding="newExercise.loadFormula"]',
        title: t('onboarding.newExercise.loadFormula.title'),
        content: t('onboarding.newExercise.loadFormula.content'),
        disableBeacon: true,
        placement: mobileView ? 'top' : 'bottom',
      },
      {
        target: '[data-onboarding="newExercise.splitBySide"]',
        title: t('onboarding.newExercise.splitBySide.title'),
        content: t('onboarding.newExercise.splitBySide.content'),
        disableBeacon: true,
        placement: mobileView ? 'top' : 'bottom',
      },
      {
        target: '[data-onboarding="newExercise.options"]',
        title: t('onboarding.newExercise.options.title'),
        content: t('onboarding.newExercise.options.content'),
        disableBeacon: true,
        placement: mobileView ? 'top' : 'bottom',
      },
      {
        target: '[data-onboarding="newExercise.description"]',
        title: t('onboarding.newExercise.description.title'),
        content: t('onboarding.newExercise.description.content'),
        disableBeacon: true,
        placement: mobileView ? 'top' : 'bottom',
      },
    ],
  },
  {
    blockKey: 'currentTrainingCrating',
    matchesRoute: (pathname) => pathname === Paths.trainings.toStartNew,
    pauseRules: [
      {
        afterStepTarget: '[data-onboarding="newTraining.addTrainingSet"]',
        resumeWhenTarget: '[data-onboarding="newTraining.exerciseSelector"]',
      },
      {
        afterStepTarget: '[data-onboarding="newTraining.exerciseSelector"]',
        resumeWhenTarget: '[data-onboarding="newTraining.firstExerciseRow"]',
      },
    ],
    completeOnClickTargets: ['[data-onboarding="newTraining.startTraining"]'],
    getSteps: ({ t, mobileView }) => [
      {
        target: '[data-onboarding="newTraining.programSelector"]',
        title: t('onboarding.newTraining.programSelector.title'),
        content: t('onboarding.newTraining.programSelector.content'),
        disableBeacon: true,
        placement: mobileView ? 'top' : 'bottom',
      },
      {
        target: '[data-onboarding="newTraining.addTrainingSet"]',
        title: t('onboarding.newTraining.addTrainingSet.title'),
        content: t('onboarding.newTraining.addTrainingSet.content'),
        disableBeacon: true,
        placement: mobileView ? 'top' : 'bottom',
      },
      {
        target: '[data-onboarding="newTraining.exerciseSelector"]',
        title: t('onboarding.newTraining.exerciseSelector.title'),
        content: t('onboarding.newTraining.exerciseSelector.content'),
        disableBeacon: true,
        placement: mobileView ? 'top' : 'bottom',
      },
      {
        target: '[data-onboarding="newTraining.firstExerciseRow"]',
        title: t('onboarding.newTraining.firstExerciseRow.title'),
        content: t('onboarding.newTraining.firstExerciseRow.content'),
        disableBeacon: true,
        placement: mobileView ? 'top' : 'bottom',
      },
      {
        target: '[data-onboarding="newTraining.addSetItem"]',
        title: t('onboarding.newTraining.addSetItemProgram.title'),
        content: t('onboarding.newTraining.addSetItemProgram.content'),
        disableBeacon: true,
        placement: mobileView ? 'top' : 'bottom',
      },
      {
        target: '[data-onboarding="newTraining.addExerciseToSuperset"]',
        title: t('onboarding.newTraining.addExerciseToSuperset.title'),
        content: t('onboarding.newTraining.addExerciseToSuperset.content'),
        disableBeacon: true,
        placement: mobileView ? 'top' : 'bottom',
      },
      {
        target: '[data-onboarding="newTraining.startTraining"]',
        title: t('onboarding.newTraining.startTraining.title'),
        content: t('onboarding.newTraining.startTraining.content'),
        disableBeacon: true,
        placement: mobileView ? 'top' : 'bottom',
      },
    ],
  },
  {
    blockKey: 'newTraining',
    matchesRoute: (pathname) => pathname === Paths.trainings.toNew,
    pauseRules: [
      {
        afterStepTarget: '[data-onboarding="newTraining.addTrainingSet"]',
        resumeWhenTarget: '[data-onboarding="newTraining.exerciseSelector"]',
      },
      {
        afterStepTarget: '[data-onboarding="newTraining.exerciseSelector"]',
        resumeWhenTarget: '[data-onboarding="newTraining.firstExerciseRow"]',
      },
    ],
    completeOnClickTargets: ['[data-onboarding="newTraining.save"]'],
    getSteps: ({ t, mobileView }) => [
      {
        target: '[data-onboarding="newTraining.programSelector"]',
        title: t('onboarding.newTraining.programSelector.title'),
        content: t('onboarding.newTraining.programSelector.content'),
        disableBeacon: true,
        placement: mobileView ? 'top' : 'bottom',
      },
      {
        target: '[data-onboarding="newTraining.addTrainingSet"]',
        title: t('onboarding.newTraining.addTrainingSet.title'),
        content: t('onboarding.newTraining.addTrainingSet.content'),
        disableBeacon: true,
        placement: mobileView ? 'top' : 'bottom',
      },
      {
        target: '[data-onboarding="newTraining.exerciseSelector"]',
        title: t('onboarding.newTraining.exerciseSelector.title'),
        content: t('onboarding.newTraining.exerciseSelector.content'),
        disableBeacon: true,
        placement: mobileView ? 'top' : 'bottom',
      },
      {
        target: '[data-onboarding="newTraining.firstExerciseRow"]',
        title: t('onboarding.newTraining.firstExerciseRow.title'),
        content: t('onboarding.newTraining.firstExerciseRow.content'),
        disableBeacon: true,
        placement: mobileView ? 'top' : 'bottom',
      },
      {
        target: '[data-onboarding="newTraining.addSetItem"]',
        title: t('onboarding.newTraining.addSetItem.title'),
        content: t('onboarding.newTraining.addSetItem.content'),
        disableBeacon: true,
        placement: mobileView ? 'top' : 'bottom',
      },
      {
        target: '[data-onboarding="newTraining.sortSets"]',
        title: t('onboarding.newTraining.sortSets.title'),
        content: t('onboarding.newTraining.sortSets.content'),
        disableBeacon: true,
        placement: mobileView ? 'top' : 'bottom',
      },
      {
        target: '[data-onboarding="newTraining.addExerciseToSuperset"]',
        title: t('onboarding.newTraining.addExerciseToSuperset.title'),
        content: t('onboarding.newTraining.addExerciseToSuperset.content'),
        disableBeacon: true,
        placement: mobileView ? 'top' : 'bottom',
      },
    ],
  },
  {
    blockKey: 'newProgram',
    matchesRoute: (pathname) => pathname === Paths.programs.toNewItem,
    pauseRules: [
      {
        afterStepTarget: '[data-onboarding="newTraining.addTrainingSet"]',
        resumeWhenTarget: '[data-onboarding="newTraining.exerciseSelector"]',
      },
      {
        afterStepTarget: '[data-onboarding="newTraining.exerciseSelector"]',
        resumeWhenTarget: '[data-onboarding="newTraining.setsCount"]',
      },
    ],
    completeOnClickTargets: ['[data-onboarding="newTraining.save"]'],
    getSteps: ({ t, mobileView }) => [
      {
        target: '[data-onboarding="newTraining.collectionSelector"]',
        title: t('onboarding.newTraining.collectionSelector.title'),
        content: t('onboarding.newTraining.collectionSelector.content'),
        disableBeacon: true,
        placement: mobileView ? 'top' : 'bottom',
      },
      {
        target: '[data-onboarding="newTraining.addTrainingSet"]',
        title: t('onboarding.newTraining.addTrainingSet.title'),
        content: t('onboarding.newTraining.addTrainingSet.content'),
        disableBeacon: true,
        placement: mobileView ? 'top' : 'bottom',
      },
      {
        target: '[data-onboarding="newTraining.exerciseSelector"]',
        title: t('onboarding.newTraining.exerciseSelector.title'),
        content: t('onboarding.newTraining.exerciseSelector.content'),
        disableBeacon: true,
        placement: mobileView ? 'top' : 'bottom',
      },
      {
        target: '[data-onboarding="newTraining.setsCount"]',
        title: t('onboarding.newTraining.setsCount.title'),
        content: t('onboarding.newTraining.setsCount.content'),
        disableBeacon: true,
        placement: mobileView ? 'top' : 'bottom',
      },
      {
        target: '[data-onboarding="newTraining.firstExerciseRow"]',
        title: t('onboarding.newTraining.firstExerciseRow.title'),
        content: t('onboarding.newTraining.firstExerciseRow.content'),
        disableBeacon: true,
        placement: mobileView ? 'top' : 'bottom',
      },
      {
        target: '[data-onboarding="newTraining.addSetItem"]',
        title: t('onboarding.newTraining.addSetItem.title'),
        content: t('onboarding.newTraining.addSetItem.content'),
        disableBeacon: true,
        placement: mobileView ? 'top' : 'bottom',
      },
      {
        target: '[data-onboarding="newTraining.sortSets"]',
        title: t('onboarding.newTraining.sortSets.title'),
        content: t('onboarding.newTraining.sortSets.content'),
        disableBeacon: true,
        placement: mobileView ? 'top' : 'bottom',
      },
      {
        target: '[data-onboarding="newTraining.addExerciseToSuperset"]',
        title: t('onboarding.newTraining.addExerciseToSuperset.title'),
        content: t('onboarding.newTraining.addExerciseToSuperset.content'),
        disableBeacon: true,
        placement: mobileView ? 'top' : 'bottom',
      },
    ],
  },
  {
    blockKey: 'programSetPage',
    matchesRoute: (pathname) => pathname === Paths.programs.toNewSet,
    pauseRules: [
      {
        afterStepTarget: '[data-onboarding="newTraining.exerciseSelector"]',
        resumeWhenTarget: '[data-onboarding="newTraining.firstExerciseRow"]',
      },
    ],
    completeOnClickTargets: ['[data-onboarding="newTraining.save"]'],
    getSteps: ({ t, mobileView }) => [
      {
        target: '[data-onboarding="newTraining.exerciseSelector"]',
        title: t('onboarding.newTraining.exerciseSelector.title'),
        content: t('onboarding.newTraining.exerciseSelector.content'),
        disableBeacon: true,
        placement: mobileView ? 'top' : 'bottom',
      },
      {
        target: '[data-onboarding="newTraining.firstExerciseRow"]',
        title: t('onboarding.newTraining.firstExerciseRow.title'),
        content: t('onboarding.newTraining.firstExerciseRow.content'),
        disableBeacon: true,
        placement: mobileView ? 'top' : 'bottom',
      },
      {
        target: '[data-onboarding="newTraining.addSetItem"]',
        title: t('onboarding.newTraining.addSetItem.title'),
        content: t('onboarding.newTraining.addSetItem.content'),
        disableBeacon: true,
        placement: mobileView ? 'top' : 'bottom',
      },
    ],
  },
  {
    blockKey: 'finishingTrainign',
    matchesRoute: (pathname) => /\/trainings\/[^/]+\/finishing$/.test(pathname),
    completeOnClickTargets: [
      '[data-onboarding="finishingTraining.finishTraining"]',
    ],
    getSteps: ({ t, mobileView }) => [
      {
        target: '[data-onboarding="finishingTraining.photos"]',
        title: t('onboarding.finishingTraining.photos.title'),
        content: t('onboarding.finishingTraining.photos.content'),
        disableBeacon: true,
        placement: mobileView ? 'top' : 'bottom',
      },
      {
        target: '[data-onboarding="finishingTraining.dates"]',
        title: t('onboarding.finishingTraining.dates.title'),
        content: t('onboarding.finishingTraining.dates.content'),
        disableBeacon: true,
        placement: mobileView ? 'top' : 'bottom',
      },
      {
        target: '[data-onboarding="finishingTraining.notes"]',
        title: t('onboarding.finishingTraining.notes.title'),
        content: t('onboarding.finishingTraining.notes.content'),
        disableBeacon: true,
        placement: mobileView ? 'top' : 'bottom',
      },
      {
        target: '[data-onboarding="finishingTraining.loadDistribution"]',
        title: t('onboarding.finishingTraining.loadDistribution.title'),
        content: t('onboarding.finishingTraining.loadDistribution.content'),
        disableBeacon: true,
        placement: mobileView ? 'top' : 'bottom',
      },
      {
        target: '[data-onboarding="finishingTraining.programActions"]',
        title: t('onboarding.finishingTraining.programActions.title'),
        content: t('onboarding.finishingTraining.programActions.content'),
        disableBeacon: true,
        placement: mobileView ? 'top' : 'bottom',
      },
      {
        target: '[data-onboarding="finishingTraining.finishTraining"]',
        title: t('onboarding.finishingTraining.finishTraining.title'),
        content: t('onboarding.finishingTraining.finishTraining.content'),
        disableBeacon: true,
        placement: mobileView ? 'top' : 'bottom',
      },
    ],
  },
  {
    blockKey: 'currentTraining',
    matchesRoute: (pathname) => /\/trainings\/[^/]+\/current$/.test(pathname),
    pauseRules: [
      {
        afterStepTarget: '[data-onboarding="currentTraining.sortSets"]',
        resumeWhenTarget: '[data-onboarding="currentTraining.editSet"]',
      },
    ],
    completeOnClickTargets: [
      '[data-onboarding="currentTraining.finishTraining"]',
    ],
    getSteps: ({ t, mobileView }) => [
      {
        target: '[data-onboarding="currentTraining.editTraining"]',
        title: t('onboarding.currentTraining.editTraining.title'),
        content: t('onboarding.currentTraining.editTraining.content'),
        disableBeacon: true,
        placement: mobileView ? 'top' : 'bottom',
      },
      {
        target: '[data-onboarding="currentTraining.deleteTraining"]',
        title: t('onboarding.currentTraining.deleteTraining.title'),
        content: t('onboarding.currentTraining.deleteTraining.content'),
        disableBeacon: true,
        placement: mobileView ? 'top' : 'bottom',
      },
      {
        target: '[data-onboarding="currentTraining.sortSets"]',
        title: t('onboarding.currentTraining.sortSets.title'),
        content: t('onboarding.currentTraining.sortSets.content'),
        disableBeacon: true,
        placement: mobileView ? 'top' : 'bottom',
      },
      {
        target: '[data-onboarding="currentTraining.editSet"]',
        title: t('onboarding.currentTraining.editSet.title'),
        content: t('onboarding.currentTraining.editSet.content'),
        disableBeacon: true,
        placement: mobileView ? 'top' : 'bottom',
      },
      {
        target: '[data-onboarding="currentTraining.firstSetFirstRow"]',
        title: t('onboarding.currentTraining.firstSetFirstRow.title'),
        content: t('onboarding.currentTraining.firstSetFirstRow.content'),
        disableBeacon: true,
        placement: mobileView ? 'top' : 'bottom',
      },
      {
        target: '[data-onboarding="currentTraining.firstSetFirstRowStatus"]',
        title: t('onboarding.currentTraining.firstSetFirstRowStatus.title'),
        content: t('onboarding.currentTraining.firstSetFirstRowStatus.content'),
        disableBeacon: true,
        placement: mobileView ? 'top' : 'bottom',
      },
      {
        target: '[data-onboarding="currentTraining.addExercise"]',
        title: t('onboarding.currentTraining.addExercise.title'),
        content: t('onboarding.currentTraining.addExercise.content'),
        disableBeacon: true,
        placement: mobileView ? 'top' : 'bottom',
      },
      {
        target: '[data-onboarding="currentTraining.finishTraining"]',
        title: t('onboarding.currentTraining.finishTraining.title'),
        content: t('onboarding.currentTraining.finishTraining.content'),
        disableBeacon: true,
        placement: mobileView ? 'top' : 'bottom',
      },
    ],
  },
  {
    blockKey: 'trainingPage',
    matchesRoute: (pathname) => pathname.startsWith(Paths.trainings.root),
    getSteps: ({ t, mobileView }) => [
      {
        target: '[data-onboarding="trainingPage.action.generateAi"]',
        title: t('onboarding.trainingPage.generateAi.title'),
        content: t('onboarding.trainingPage.generateAi.content'),
        disableBeacon: true,
        placement: mobileView ? 'top' : 'bottom',
      },
      {
        target: '[data-onboarding="trainingPage.action.startNow"]',
        title: t('onboarding.trainingPage.startNow.title'),
        content: t('onboarding.trainingPage.startNow.content'),
        disableBeacon: true,
        placement: mobileView ? 'top' : 'bottom',
      },
      {
        target: '[data-onboarding="trainingPage.action.createFuture"]',
        title: t('onboarding.trainingPage.createFuture.title'),
        content: t('onboarding.trainingPage.createFuture.content'),
        disableBeacon: true,
        placement: mobileView ? 'top' : 'bottom',
      },
      {
        target: '[data-onboarding="trainingPage.tab.my"]',
        title: t('onboarding.trainingPage.tabs.my.title'),
        content: t('onboarding.trainingPage.tabs.my.content'),
        disableBeacon: true,
        placement: mobileView ? 'top' : 'bottom',
      },
      {
        target: '[data-onboarding="trainingPage.tab.fromMe"]',
        title: t('onboarding.trainingPage.tabs.fromMe.title'),
        content: t('onboarding.trainingPage.tabs.fromMe.content'),
        disableBeacon: true,
        placement: mobileView ? 'top' : 'bottom',
      },
      {
        target: '[data-onboarding="trainingPage.tab.available"]',
        title: t('onboarding.trainingPage.tabs.available.title'),
        content: t('onboarding.trainingPage.tabs.available.content'),
        disableBeacon: true,
        placement: mobileView ? 'top' : 'bottom',
      },
    ],
  },
  {
    blockKey: 'programPage',
    matchesRoute: (pathname) => pathname.startsWith(Paths.programs.root),
    getSteps: ({ t, mobileView }) => [
      {
        target: '[data-onboarding="programPage.action.createProgram"]',
        title: t('onboarding.programPage.createProgram.title'),
        content: t('onboarding.programPage.createProgram.content'),
        disableBeacon: true,
        placement: mobileView ? 'top' : 'bottom',
      },
      {
        target: '[data-onboarding="programPage.tab.items"]',
        title: t('onboarding.programPage.tabs.items.title'),
        content: t('onboarding.programPage.tabs.items.content'),
        disableBeacon: true,
        placement: mobileView ? 'top' : 'bottom',
      },
      {
        target: '[data-onboarding="programPage.tab.sets"]',
        title: t('onboarding.programPage.tabs.sets.title'),
        content: t('onboarding.programPage.tabs.sets.content'),
        disableBeacon: true,
        placement: mobileView ? 'top' : 'bottom',
      },
      {
        target: '[data-onboarding="programPage.tab.collections"]',
        title: t('onboarding.programPage.tabs.collections.title'),
        content: t('onboarding.programPage.tabs.collections.content'),
        disableBeacon: true,
        placement: mobileView ? 'top' : 'bottom',
      },
      {
        target: '[data-onboarding="programPage.tab.available"]',
        title: t('onboarding.programPage.tabs.available.title'),
        content: t('onboarding.programPage.tabs.available.content'),
        disableBeacon: true,
        placement: mobileView ? 'top' : 'bottom',
      },
    ],
  },
  {
    blockKey: 'exercsiePage',
    matchesRoute: (pathname) => pathname.startsWith(Paths.exercises.root),
    getSteps: ({ t, mobileView }) => [
      {
        target: '[data-onboarding="exercsiePage.action.filters"]',
        title: t('onboarding.exercsiePage.filters.title'),
        content: t('onboarding.exercsiePage.filters.content'),
        disableBeacon: true,
        placement: mobileView ? 'top' : 'bottom',
      },
      {
        target: '[data-onboarding="exercsiePage.action.createExercise"]',
        title: t('onboarding.exercsiePage.createExercise.title'),
        content: t('onboarding.exercsiePage.createExercise.content'),
        disableBeacon: true,
        placement: mobileView ? 'top' : 'bottom',
      },
      {
        target: '[data-onboarding="exercsiePage.tab.public"]',
        title: t('onboarding.exercsiePage.tabs.public.title'),
        content: t('onboarding.exercsiePage.tabs.public.content'),
        disableBeacon: true,
        placement: mobileView ? 'top' : 'bottom',
      },
      {
        target: '[data-onboarding="exercsiePage.tab.my"]',
        title: t('onboarding.exercsiePage.tabs.my.title'),
        content: t('onboarding.exercsiePage.tabs.my.content'),
        disableBeacon: true,
        placement: mobileView ? 'top' : 'bottom',
      },
    ],
  },
];

export const getActiveOnboardingBlock = (
  pathname: string,
  pendingBlockKeys: string[],
): IOnboardingBlockDefinition | null => {
  const pendingSet = new Set(pendingBlockKeys);

  return (
    onboardingBlockDefinitions.find(
      (definition) =>
        pendingSet.has(definition.blockKey) &&
        definition.matchesRoute(pathname),
    ) ?? null
  );
};

export const isKnownOnboardingBlockKey = (
  key: string,
): key is IOnboardingBlockKey => {
  return (ONBOARDING_BLOCK_KEYS as readonly string[]).includes(key);
};
